//
import { ModuleLayout } from '@/components/reusable_components/next'

//
import AccountConciliationCreateView from '@/views/Accounting/AccAccountConciliation/AccAccountConciliationCreate'

//
export default {
    path: 'account_conciliation',
    component: ModuleLayout,
    children: [
        {
            path: '',
            name: 'account-conciliation-create',
            component: AccountConciliationCreateView,
        },
    ],
    meta: {
        title: 'Conciliaciones de cuentas',
    },
}
